/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PersonRefResponse } from './PersonRefResponse';
export type SubscriptionTransactionDetailResponse = {
    id: string;
    type: SubscriptionTransactionDetailResponse.type;
    expert?: PersonRefResponse;
    planName?: Record<string, any>;
    /**
     * Plan or addon validity in days
     */
    validityDays?: Record<string, any>;
    amount: string;
    status: string;
    paymentMethod?: Record<string, any>;
    /**
     * Purchase date
     */
    purchasedAt: string;
    startDate: string;
    endDate?: Record<string, any>;
};
export namespace SubscriptionTransactionDetailResponse {
    export enum type {
        SUBSCRIPTION = 'subscription',
        ADDON = 'addon',
    }
}

